var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.formModel.fieldSets),function(fieldSet){return _c('div',{staticClass:"field"},[_c('field-set-form',{ref:"forms",refInFor:true,attrs:{"field-set-model":fieldSet},model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }